const urls = {
  saveSelectedPlace: () => {
    return `/places/v1/analytics/sauron/selection`;
  },
  searchSauron: (searchText: string) => {
    return `/sauron/autocomplete?text=${searchText}`;
  },
  placesSearch: (searchText: string) => {
    return `/places/getPlacesByMatchedExp?searchText=${searchText}&oId=${localStorage.getItem('opid_trucking')}`;
  },
  searchVehicle: (searchText: string) => {
    return `/vehicle/vehiclesByLike?exp=${searchText}&oId=${localStorage.getItem('opid_trucking')}`;
  },
  searchConsigner: (searchText: string) => {
    return `/consigner/getContractConsignerByMatchedExp?searchText=${searchText}&oId=${localStorage.getItem(
      'opid_trucking',
    )}`;
  },
  searchUnloadingPoint: (payload: any) => {
    return `/odin/v2/map/app/search?text=${payload.searchText}&addressTypes=${payload.addressTypes}`;
  },
};

export default urls;
